import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-9e6dc9e3.js';
import 'classnames';

var TickCircle = createSvgIcon(React__default.createElement(React__default.Fragment, null,
    React__default.createElement("circle", { cx: "12", cy: "12", fill: "#FDEEEE", r: "10", transform: "rotate(90 12 12)" }),
    React__default.createElement("circle", { cx: "12", cy: "12", fill: "#164CA3", r: "10" }),
    React__default.createElement("path", { d: "m6.5 11.5 3.667 3.5L17.5 8", fill: "none", stroke: "#fff", "stroke-width": "2" })), 'TickCircle');

export { TickCircle };
